import Fuse from 'fuse.js';

export const MAX_RESULTS = 10;
const PREFIXES = ['STR-AIR-', 'STR-VRBO-', 'STR-Booking-'];

export function performPropertySearch({ searchParam }, data) {
  if (!data) return null;
  let keyword = searchParam;
  for (let i = 0; i < PREFIXES.length; i++) {
    keyword = keyword.replace(PREFIXES[i], '');
  }
  keyword = keyword?.split('-').join(' ').toLowerCase();
  return new Fuse(data, {
    threshold: 0.2,
    ignoreLocation: true,
    includeScore: true,
    keys: ['address', 'apn', 'strLicense', 'listingIds'],
  })
    .search(keyword)
    .map(({ item }) => item)
    .slice(0, MAX_RESULTS);
}
